import type { ReactNode } from 'react';

export const symbol_bottom_panel_open: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M380-527h200q9.92 0 13.46-9.5Q597-546 590-553l-89-89q-9-9-21-9t-21 9l-89 89q-7 7-3.46 16.5T380-527ZM180-120q-24.75 0-42.37-17.63Q120-155.25 120-180v-600q0-24.75 17.63-42.38Q155.25-840 180-840h600q24.75 0 42.38 17.62Q840-804.75 840-780v600q0 24.75-17.62 42.37Q804.75-120 780-120H180Zm0-207v147h600v-147H180Zm0-60h600v-393H180v393Zm0 60v147-147Z"
		/>
	</svg>
);
